export default __webpack_public_path__ + "static/media/1045.3e6944b3.png";